import { Sparkles, Gem, Feather, Infinity as InfinityIcon } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { WHY } from "@/data/site";

const ICONS = [Sparkles, Gem, Feather, InfinityIcon];

export function WhyNoora() {
  return (
    <section className="border-y border-black/5 bg-beige py-24 md:py-32" data-testid="why-noora">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal className="mb-16 text-center">
          <p className="eyebrow text-gold">The Noora Promise</p>
          <h2 className="mx-auto mt-4 max-w-2xl font-serif text-4xl font-light leading-tight tracking-tight text-ink md:text-6xl">
            Why Noora Jewels
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 gap-x-8 gap-y-14 sm:grid-cols-2 lg:grid-cols-4">
          {WHY.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal
                key={item.title}
                delay={i * 0.1}
                className="flex flex-col items-center text-center"
                data-testid={`why-${item.title.replace(/\s+/g, "-").toLowerCase()}`}
              >
                <span className="grid h-16 w-16 place-items-center rounded-full border border-gold/40 text-gold">
                  <Icon size={26} strokeWidth={1.2} />
                </span>
                <h3 className="mt-6 font-serif text-2xl text-ink">{item.title}</h3>
                <p className="mt-3 max-w-[220px] text-sm leading-relaxed text-ink/60">{item.text}</p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
